import React, { useEffect, useState } from 'react';

interface Props {
}

const Cross: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {

	return (
    <svg version="1.1"  {...props} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"  width={props.style?.width || 25} height={props.style?.height || 25} style={props.style}
	 viewBox="0 0 512 512">
<g>
	<g>
		<path d="M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256
			s26.629,132.667,74.98,181.02C123.333,485.371,187.62,512,256,512s132.667-26.629,181.02-74.98
			C485.371,388.667,512,324.38,512,256S485.371,123.333,437.02,74.98z M415.806,415.806C373.12,458.492,316.367,482,256,482
			s-117.12-23.508-159.806-66.194C53.508,373.12,30,316.367,30,256S53.508,138.88,96.194,96.194C138.88,53.508,195.633,30,256,30
			s117.12,23.508,159.806,66.194C458.492,138.88,482,195.633,482,256S458.492,373.12,415.806,415.806z"/>
	</g>
</g>
<g>
	<g>
		<path d="M319.261,192.738v-88.315H192.738v88.315h-88.315v126.523h88.315v88.315h126.523v-88.315h88.315V192.738H319.261z
			 M377.577,289.261h-88.315v88.315h-66.523v-88.315h-88.315v-66.523h88.315v-88.315h66.523v88.315h88.315V289.261z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
	);
};

export {Cross};